import {FormikValues} from "formik";

export const setFormikFieldValueByName = (formik: FormikValues, fieldName: string, value: any) => {
    formik.values[fieldName] = value;
    formik.setValues(formik.values);
};
